import React from "react";

const EventReport = ({ player }) => {
  const [activeTab, setActiveTab] = React.useState("basic");
  const isMobile = window.innerWidth <= 768;

  // Fake data for the stats table
  const gameStats = [
    {
      opponent: "JSerra Catholic",
      minutes: "32",
      fgm: "7",
      fga: "11",
      fgPct: "63.64%",
      threePtMade: "3",
      threePtAttempt: "5",
      threePtPct: "60.00%",
      ftm: "4",
      fta: "4",
      ftPct: "100.00%",
      offReb: "1",
      defReb: "3",
      totReb: "4",
      pf: "2",
      ast: "3",
      to: "1",
      ratio: "3",
      blk: "0",
      stl: "1",
      pts: "21",
      tsPct: "77.27%",
      efgPct: "68.38%",
      ppp: "1.85",
      totalReboundPercentage: "21",
      offensiveReboundPercentage: "39",
      defensiveReboundPercentage: "61",
      assistedFG: "52",
      turnoverPercentage: "16",
      blockPercentage: "3",
      stealPercentage: "7",
      usageRate: "21",
      offensiveRating: "92",
      defensiveRating: "88",
    },
    {
      opponent: "Davis",
      minutes: "30",
      fgm: "4",
      fga: "13",
      fgPct: "30.77%",
      threePtMade: "1",
      threePtAttempt: "8",
      threePtPct: "16.67%",
      ftm: "3",
      fta: "4",
      ftPct: "75.00%",
      offReb: "1",
      defReb: "1",
      totReb: "2",
      pf: "2",
      ast: "1",
      to: "4",
      ratio: "0.25",
      blk: "0",
      stl: "0",
      pts: "12",
      tsPct: "34.62%",
      efgPct: "43.23%",
      ppp: "0.84",
      totalReboundPercentage: "21",
      offensiveReboundPercentage: "39",
      defensiveReboundPercentage: "61",
      assistedFG: "52",
      turnoverPercentage: "16",
      blockPercentage: "3",
      stealPercentage: "7",
      usageRate: "21",
      offensiveRating: "92",
      defensiveRating: "88",
    },
    {
      opponent: "Rolling Hills",
      minutes: "32",
      fgm: "3",
      fga: "13",
      fgPct: "23.08%",
      threePtMade: "2",
      threePtAttempt: "9",
      threePtPct: "22.22%",
      ftm: "3",
      fta: "4",
      ftPct: "75.00%",
      offReb: "0",
      defReb: "3",
      totReb: "3",
      pf: "4",
      ast: "0",
      to: "1",
      ratio: "0.00",
      blk: "0",
      stl: "0",
      pts: "11",
      tsPct: "30.77%",
      efgPct: "39.83%",
      ppp: "0.70",
      totalReboundPercentage: "21",
      offensiveReboundPercentage: "39",
      defensiveReboundPercentage: "61",
      assistedFG: "52",
      turnoverPercentage: "16",
      blockPercentage: "3",
      stealPercentage: "7",
      usageRate: "21",
      offensiveRating: "92",
      defensiveRating: "88",
    },
  ];

  const totals = {
    opponent: "Event Totals",
    minutes: "94",
    fgm: "14",
    fga: "37",
    fgPct: "37.84%",
    threePtMade: "6",
    threePtAttempt: "20",
    threePtPct: "30.00%",
    ftm: "10",
    fta: "12",
    ftPct: "83.33%",
    offReb: "2",
    defReb: "7",
    totReb: "9",
    pf: "8",
    ast: "4",
    to: "5",
    ratio: "0.80",
    blk: "0",
    stl: "1",
    pts: "44",
    tsPct: "45.85%",
    efgPct: "55.50%",
    ppp: "0.93",
    totalReboundPercentage: "21",
    offensiveReboundPercentage: "39",
    defensiveReboundPercentage: "61",
    assistedFG: "52",
    turnoverPercentage: "16",
    blockPercentage: "3",
    stealPercentage: "7",
    usageRate: "21",
    offensiveRating: "92",
    defensiveRating: "88",
  };

  return (
    <div className="event-report-container">
      <div className="event-report-header">
        <div className="event-report-triangle-bg">
          <img
            src={player.image_url}
            alt={player.player_name}
            className="event-report-player-image"
          />
          <h1 className="event-report-name">{player.player_name}</h1>
        </div>

        {isMobile ? (
          <>
            <div>
              <div className="event-report-detail event-report-detail-full">
                <div className="event-report-event-header">
                  <img
                    src="https://az.nhsbca.org/hs-fs/hubfs/S7_2023.png?width=400&height=402&name=S7_2023.png"
                    alt="Section 7"
                    className="event-report-event-logo"
                  />
                  <span className="event-report-value event-report-event-name">
                    Section 7
                  </span>
                </div>
              </div>
            </div>

            <div className="event-report-mobile-tabs">
              <div className="event-report-tab-buttons">
                <button
                  className={`event-report-tab-button ${
                    activeTab === "basic" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("basic")}
                >
                  Basic Info
                </button>
                <button
                  className={`event-report-tab-button ${
                    activeTab === "overall" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("overall")}
                >
                  Overall Stats
                </button>
                <button
                  className={`event-report-tab-button ${
                    activeTab === "table" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("table")}
                >
                  Game Stats
                </button>
                <button
                  className={`event-report-tab-button ${
                    activeTab === "shotchart" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("shotchart")}
                >
                  Shot Chart
                </button>
              </div>

              {activeTab === "basic" && (
                <div>
                  <div className="event-report-info">
                    <div className="event-report-detail">
                      <span className="event-report-label">DATE OF BIRTH</span>
                      <span className="event-report-value">{player.class}</span>
                    </div>
                    <div className="event-report-detail">
                      <span className="event-report-label">SCHOOL</span>
                      <span className="event-report-value">GARFIELD</span>
                    </div>
                    <div className="event-report-detail">
                      <span className="event-report-label">HEIGHT</span>
                      <span className="event-report-value">
                        {player.height}
                      </span>
                    </div>
                    <div className="event-report-detail">
                      <span className="event-report-label">POSITION</span>
                      <span className="event-report-value">
                        {player.position}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "overall" && (
                <div className="event-report-overall-stats">
                  <h2>OVERALL STATS</h2>
                  <div className="event-report-stats-box">
                    <div className="event-report-stat">
                      <span className="event-report-stat-value">14.67</span>
                      <span className="event-report-stat-label">PPG</span>
                    </div>
                    <div className="event-report-stat">
                      <span className="event-report-stat-value">3.00</span>
                      <span className="event-report-stat-label">RPG</span>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "table" && (
                <div className="event-report-table-container">
                  <table className="event-report-table">
                    <thead>
                      <tr>
                        <th>vs</th>
                        <th>MIN</th>
                        <th>FGM</th>
                        <th>FGA</th>
                        <th>PCT</th>
                        <th>3FGM</th>
                        <th>3FGA</th>
                        <th>3PT%</th>
                        <th>FTM</th>
                        <th>FTA</th>
                        <th>FT%</th>
                        <th>OFF REB</th>
                        <th>DEF REB</th>
                        <th>TOT REB</th>
                        <th>PF</th>
                        <th>A</th>
                        <th>TO</th>
                        <th>A/TO</th>
                        <th>BLK</th>
                        <th>STL</th>
                        <th>PTS</th>
                        <th>TS%</th>
                        <th>EFG%</th>
                        <th>PPP</th>
                        <th>TRB%</th>
                        <th>OREB%</th>
                        <th>DREB%</th>
                        <th>AST FG%</th>
                        <th>TO%</th>
                        <th>BLK%</th>
                        <th>STL%</th>
                        <th>USG%</th>
                        <th>OFFRtg</th>
                        <th>DEFRtg</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gameStats.map((game, index) => (
                        <tr key={index}>
                          <td>{game.opponent}</td>
                          <td>{game.minutes}</td>
                          <td>{game.fgm}</td>
                          <td>{game.fga}</td>
                          <td>{game.fgPct}</td>
                          <td>{game.threePtMade}</td>
                          <td>{game.threePtAttempt}</td>
                          <td>{game.threePtPct}</td>
                          <td>{game.ftm}</td>
                          <td>{game.fta}</td>
                          <td>{game.ftPct}</td>
                          <td>{game.offReb}</td>
                          <td>{game.defReb}</td>
                          <td>{game.totReb}</td>
                          <td>{game.pf}</td>
                          <td>{game.ast}</td>
                          <td>{game.to}</td>
                          <td>{game.ratio}</td>
                          <td>{game.blk}</td>
                          <td>{game.stl}</td>
                          <td>{game.pts}</td>
                          <td>{game.tsPct}</td>
                          <td>{game.efgPct}</td>
                          <td>{game.ppp}</td>
                          <td>{game.totalReboundPercentage}</td>
                          <td>{game.offensiveReboundPercentage}</td>
                          <td>{game.defensiveReboundPercentage}</td>
                          <td>{game.assistedFG}</td>
                          <td>{game.turnoverPercentage}</td>
                          <td>{game.blockPercentage}</td>
                          <td>{game.stealPercentage}</td>
                          <td>{game.usageRate}</td>
                          <td>{game.offensiveRating}</td>
                          <td>{game.defensiveRating}</td>
                        </tr>
                      ))}
                      <tr className="event-report-totals">
                        <td>{totals.opponent}</td>
                        <td>{totals.minutes}</td>
                        <td>{totals.fgm}</td>
                        <td>{totals.fga}</td>
                        <td>{totals.fgPct}</td>
                        <td>{totals.threePtMade}</td>
                        <td>{totals.threePtAttempt}</td>
                        <td>{totals.threePtPct}</td>
                        <td>{totals.ftm}</td>
                        <td>{totals.fta}</td>
                        <td>{totals.ftPct}</td>
                        <td>{totals.offReb}</td>
                        <td>{totals.defReb}</td>
                        <td>{totals.totReb}</td>
                        <td>{totals.pf}</td>
                        <td>{totals.ast}</td>
                        <td>{totals.to}</td>
                        <td>{totals.ratio}</td>
                        <td>{totals.blk}</td>
                        <td>{totals.stl}</td>
                        <td>{totals.pts}</td>
                        <td>{totals.tsPct}</td>
                        <td>{totals.efgPct}</td>
                        <td>{totals.ppp}</td>
                        <td>{totals.totalReboundPercentage}</td>
                        <td>{totals.offensiveReboundPercentage}</td>
                        <td>{totals.defensiveReboundPercentage}</td>
                        <td>{totals.assistedFG}</td>
                        <td>{totals.turnoverPercentage}</td>
                        <td>{totals.blockPercentage}</td>
                        <td>{totals.stealPercentage}</td>
                        <td>{totals.usageRate}</td>
                        <td>{totals.offensiveRating}</td>
                        <td>{totals.defensiveRating}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === "shotchart" && (
                <div className="event-report-shotchart">
                  <img
                    src="/shotchart-advanced.jpeg"
                    alt="Shot Chart"
                    className="event-report-shotchart-image"
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="event-report-detail event-report-detail-full">
                <div className="event-report-event-header">
                  <img
                    src="https://az.nhsbca.org/hs-fs/hubfs/S7_2023.png?width=400&height=402&name=S7_2023.png"
                    alt="Section 7"
                    className="event-report-event-logo"
                  />
                  <span className="event-report-value event-report-event-name">
                    Section 7
                  </span>
                </div>
              </div>
              <div className="event-report-info">
                <div className="event-report-detail">
                  <span className="event-report-label">DATE OF BIRTH</span>
                  <span className="event-report-value">{player.class}</span>
                </div>
                <div className="event-report-detail">
                  <span className="event-report-label">SCHOOL</span>
                  <span className="event-report-value">GARFIELD</span>
                </div>
                <div className="event-report-detail">
                  <span className="event-report-label">HEIGHT</span>
                  <span className="event-report-value">{player.height}</span>
                </div>
                <div className="event-report-detail">
                  <span className="event-report-label">POSITION</span>
                  <span className="event-report-value">{player.position}</span>
                </div>
              </div>
            </div>
            <div className="event-report-overall-stats">
              <h2>OVERALL STATS</h2>
              <div className="event-report-stats-box">
                <div className="event-report-stat">
                  <span className="event-report-stat-value">14.67</span>
                  <span className="event-report-stat-label">PPG</span>
                </div>
                <div className="event-report-stat">
                  <span className="event-report-stat-value">3.00</span>
                  <span className="event-report-stat-label">RPG</span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {!isMobile && (
        <div className="event-report-table-container">
          <table className="event-report-table">
            <thead>
              <tr>
                <th>vs</th>
                <th>MIN</th>
                <th>FGM</th>
                <th>FGA</th>
                <th>PCT</th>
                <th>3FGM</th>
                <th>3FGA</th>
                <th>3PT%</th>
                <th>FTM</th>
                <th>FTA</th>
                <th>FT%</th>
                <th>OFF REB</th>
                <th>DEF REB</th>
                <th>TOT REB</th>
                <th>PF</th>
                <th>A</th>
                <th>TO</th>
                <th>A/TO</th>
                <th>BLK</th>
                <th>STL</th>
                <th>PTS</th>
                <th>TS%</th>
                <th>EFG%</th>
                <th>PPP</th>
                <th>TRB%</th>
                <th>OREB%</th>
                <th>DREB%</th>
                <th>AST FG%</th>
                <th>TO%</th>
                <th>BLK%</th>
                <th>STL%</th>
                <th>USG%</th>
                <th>OFFRtg</th>
                <th>DEFRtg</th>
              </tr>
            </thead>
            <tbody>
              {gameStats.map((game, index) => (
                <tr key={index}>
                  <td>{game.opponent}</td>
                  <td>{game.minutes}</td>
                  <td>{game.fgm}</td>
                  <td>{game.fga}</td>
                  <td>{game.fgPct}</td>
                  <td>{game.threePtMade}</td>
                  <td>{game.threePtAttempt}</td>
                  <td>{game.threePtPct}</td>
                  <td>{game.ftm}</td>
                  <td>{game.fta}</td>
                  <td>{game.ftPct}</td>
                  <td>{game.offReb}</td>
                  <td>{game.defReb}</td>
                  <td>{game.totReb}</td>
                  <td>{game.pf}</td>
                  <td>{game.ast}</td>
                  <td>{game.to}</td>
                  <td>{game.ratio}</td>
                  <td>{game.blk}</td>
                  <td>{game.stl}</td>
                  <td>{game.pts}</td>
                  <td>{game.tsPct}</td>
                  <td>{game.efgPct}</td>
                  <td>{game.ppp}</td>
                  <td>{game.totalReboundPercentage}</td>
                  <td>{game.offensiveReboundPercentage}</td>
                  <td>{game.defensiveReboundPercentage}</td>
                  <td>{game.assistedFG}</td>
                  <td>{game.turnoverPercentage}</td>
                  <td>{game.blockPercentage}</td>
                  <td>{game.stealPercentage}</td>
                  <td>{game.usageRate}</td>
                  <td>{game.offensiveRating}</td>
                  <td>{game.defensiveRating}</td>
                </tr>
              ))}
              <tr className="event-report-totals">
                <td>{totals.opponent}</td>
                <td>{totals.minutes}</td>
                <td>{totals.fgm}</td>
                <td>{totals.fga}</td>
                <td>{totals.fgPct}</td>
                <td>{totals.threePtMade}</td>
                <td>{totals.threePtAttempt}</td>
                <td>{totals.threePtPct}</td>
                <td>{totals.ftm}</td>
                <td>{totals.fta}</td>
                <td>{totals.ftPct}</td>
                <td>{totals.offReb}</td>
                <td>{totals.defReb}</td>
                <td>{totals.totReb}</td>
                <td>{totals.pf}</td>
                <td>{totals.ast}</td>
                <td>{totals.to}</td>
                <td>{totals.ratio}</td>
                <td>{totals.blk}</td>
                <td>{totals.stl}</td>
                <td>{totals.pts}</td>
                <td>{totals.tsPct}</td>
                <td>{totals.efgPct}</td>
                <td>{totals.ppp}</td>
                <td>{totals.totalReboundPercentage}</td>
                <td>{totals.offensiveReboundPercentage}</td>
                <td>{totals.defensiveReboundPercentage}</td>
                <td>{totals.assistedFG}</td>
                <td>{totals.turnoverPercentage}</td>
                <td>{totals.blockPercentage}</td>
                <td>{totals.stealPercentage}</td>
                <td>{totals.usageRate}</td>
                <td>{totals.offensiveRating}</td>
                <td>{totals.defensiveRating}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {!isMobile && (
        <div className="event-report-shotchart-section">
          <h2 className="event-report-section-title">Shot Chart</h2>
          <div className="event-report-shotchart">
            <img
              src="/shotchart-advanced.jpeg"
              alt="Shot Chart"
              className="event-report-shotchart-image"
            />
          </div>
        </div>
      )}

      <div className="event-report-footer">
        <p>
          PPG = POINTS PER GAME, RPG = REBOUNDS PER GAME, PPP = POINTS PER
          POSSESSION
        </p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>Powered by</span>
          <img
            src="/xsmlgsm.PNG"
            alt="Powered by"
            className="event-report-powered-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default EventReport;
